import { atom, useRecoilState, useResetRecoilState } from 'recoil'

const activeEquipmentState = atom({
  key: 'supervision-active-equipment',
  default: {}
})
const filtersState = atom({
  key: 'supervision-filters',
  default: {
    buildingName: '',
    verbatim: '',
    status: [],
    hardwares: [],
    models: [],
    manufacturers: []
  },
})

const sortState = atom({
  key: 'SupervisionSort',
  default: {
    by: 'name',
    direction: 'desc',
  },
})

export const useFilters = () => {
  return useRecoilState(filtersState)
}
export const useSort = () => {
  const [{ direction, by }, setSort] = useRecoilState(sortState)
  return [
    { direction, by },
    (sort) => {
      if (by === sort) {
        const newDirection = direction === 'asc' ? 'desc' : 'asc'
        setSort({ by: sort, direction: newDirection })
      } else {
        setSort({ by: sort, direction: 'asc' })
      }
    },
  ]
}

export const useResetFilters = () => {
  return useResetRecoilState(filtersState)
}

export const useActiveEquipment = () => {
  return useRecoilState(activeEquipmentState)
}

